<script>
export default {
  props: {
    image: {
      type: String,
      required: true,
      default: null,
    },
    round: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<template>
  <div class="image-thumbnail">
    <img :class="{ round: round }" v-lazy="image" />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.image-thumbnail {
  height: 100%;
  margin-right: 3.4rem;
  width: 10rem;

  img {
    border-radius: $base-border-radius;
    width: 100%;

    &.round {
      border-radius: 50%;
    }
  }
}
</style>
